export default {
  alert: {
    margin: '#10px'
  }
};
